import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import {getTabapayStatus} from '../../../actions/tabapay/browser';
import {useGenericStatusPage} from '../../../hooks/useGenericStatusPage';
import propLoaders from '../../../prop-loaders';
import {getLanguageCode, getTranslations} from '../../../utils/selectors';
import StatusPageSpinner from '../../molecules/StatusPageSpinner';

const TabapayStatusWaiting = ({
    dispatch,
    languageCode,
    initData,
    initError,
    match,
    translations
}) => {
    const {
        statusPage: {
            spinner: {
                title,
                subTitle
            }
        }
    } = translations;
    const {paymentSessionId} = match.params;

    useGenericStatusPage({
        paymentSessionId,
        languageCode,
        dispatch,
        initData,
        initError,
        getPaymentStatus: getTabapayStatus
    });

    return (
        <StatusPageSpinner title={title} subTitle={subTitle} />
    );
};


TabapayStatusWaiting.getServerSideProps = async ({
    requestId,
    sessionId,
    params: {
        paymentSessionId
    }
}) => {
    try {
        const initData = await propLoaders.getTabapayStatus(
            {requestId, sessionId, query: {paymentSessionId}}
        );
        return {
            initData
        };
    } catch (error) {
        return {
            initError: error
        };
    }
};

TabapayStatusWaiting.propTypes = {
    initData: PropTypes.shape({
        sessionId: PropTypes.string.isRequired,
        redirectUrl: PropTypes.string
    }),
    initError: PropTypes.number,
    match: PropTypes.shape({
        params: PropTypes.shape({
            paymentSessionId: PropTypes.string.isRequired,
            language: PropTypes.string.isRequired
        }).isRequired
    }).isRequired
};

TabapayStatusWaiting.defaultProps = {
    initData: undefined,
    initError: null
};

const mapStateToProps = state => ({
    languageCode: getLanguageCode(state),
    translations: getTranslations(state)
});

export default connect(mapStateToProps)(TabapayStatusWaiting);
